import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component, useContext } from 'react'
import routes from 'shared/routes'
import css from './login.css'
import appendNext from 'shared/components/form/get-next-url'
import ModalContext from 'shared/components/context/modal'
import UserContext from 'shared/components/context/user'

export default class Login extends Component {
    static propTypes = {
        user: PropTypes.object,
    }
    componentDidMount() {
        // dashboard legacy checks
        window.Giphy.UserEdit && window.Giphy.UserEdit.userSettingsInit()
    }
    render() {
        const { user } = this.props
        return (
            <div>
                <div className={css.defaultNav}>{user ? <LoggedIn /> : <LoggedOut />}</div>
            </div>
        )
    }
}

const LoggedIn = () => {
    const { openCollectionCabinet } = useContext(ModalContext)
    const { user } = useContext(UserContext)
    if (!user) {
        // in case we miss wrapping something with contexts
        // we'll know right away in trackjs
        console.error(`Missing context for ${location.pathname}`)
        return null
    }
    const {
        displayName,
        avatar,
        username,
        isStaff,
        permissions: { dashboard_link, create_stories, manage_own_subchannels, access_dvr },
    } = user

    return (
        <a className={css.user} href={`/channel/${username}`}>
            <div className={css.userInfo}>
                <span className={css.avatar} style={{ backgroundImage: `url(${avatar})` }} />
                <span className={css.username}>{displayName || username}</span>
            </div>
            <div className={css.caret}>
                <i className="ss-icon ss-dropdown" />
            </div>
            <ul className={css.partnerNavMenu}>
                {dashboard_link && (
                    <li>
                        <a href={routes.DASHBOARD.path}>Dashboard</a>
                    </li>
                )}
                {manage_own_subchannels && (
                    <li>
                        <a
                            href=""
                            onClick={e => {
                                e.preventDefault()
                                openCollectionCabinet()
                            }}
                        >
                            Collections
                        </a>
                    </li>
                )}
                <li>
                    <a href="/settings">Settings</a>
                </li>
                {create_stories && (
                    <li>
                        <a href={routes.STORYBOOK.path}>Storybook</a>
                    </li>
                )}
                <li>
                    <a href={routes.FAVORITES.path}>Favorites</a>
                </li>
                {isStaff && (
                    <li>
                        <a href="/edit/channels">Channels</a>
                    </li>
                )}
                {(access_dvr || isStaff) && (
                    <li>
                        <a href="/dvr">Super Cut</a>
                    </li>
                )}
                <li>
                    <a href="/logout">Log Out</a>
                </li>
            </ul>
        </a>
    )
}

const LoggedOut = () => {
    const isLogin = location.pathname === routes.LOGIN.path
    return (
        <a
            id="login-button"
            className={css.loginJoinButton}
            rel="nofollow"
            href={appendNext(`/${isLogin ? 'join' : 'login'}`)}
        >
            <i className={`${css.userIcon} ss-user`} />
            <span className="nav-text">{isLogin ? 'Join' : 'Log In'}</span>
        </a>
    )
}
